import * as API from "./api";
import * as Types from "./Types";
import * as Storages from "../../helpers/Storages";
import * as Strings from "./strings";

export function tryValidateUser() {
  return dispatch => {
    dispatch({
      type: Types.VALIDATE_USER
    });

    API.validateUser(Storages.getToken())
      .then(response => {
        Storages.setToken(response.data.data.token);

        dispatch({
          type: Types.VALIDATE_USER_SUCCESS,
          payload: response.data.data
        });
      })
      .catch(error => {
        Storages.removeToken();

        dispatch({
          type: Types.VALIDATE_USER_FAILED
        });
      });
  };
}

export function trySignIn(data, showAlert) {
  return dispatch => {
    dispatch({
      type: Types.SIGN_IN_USER
    });

    API.signIn(data)
      .then(response => {
        Storages.setToken(response.data.data.token);

        dispatch({
          type: Types.SIGN_IN_USER_SUCCESS,
          payload: response.data.data
        });
      })
      .catch(error => {
        if (error.response && error.response.status === 401) {
          showAlert(
            Strings.default.UNAUTHORIZED_HEADER,
            Strings.default.UNAUTHORIZED,
            {
              title: Strings.default.OK,
              onPress: () => {}
            }
          );
        } else {
          showAlert(
            Strings.default.INTERNAL_ERROR_HEADER,
            Strings.default.INTERNAL_ERROR,
            {
              title: Strings.default.OK,
              onPress: () => {}
            }
          );
        }

        dispatch({
          type: Types.SIGN_IN_USER_FAILED
        });
      });
  };
}

export function signOut() {
  return dispatch => {
    Storages.removeToken();

    dispatch({
      type: Types.SIGN_OUT_USER
    });
  };
}



// WEBPACK FOOTER //
// ./src/components/actions/User.js